import { Transcription } from "@getsubly/common";

export const getTranscriptionDurationMs = (
  transcription: Transcription
): number =>
  transcription.reduce(
    (acc: number, cue) => (cue.end > acc ? cue.end : acc),
    0
  );
